import { ActivatedRouteSnapshot, Router } from "@angular/router";
import {Observable, of} from "rxjs";
import { CompetitorService } from "@services";
import { Competitor, PagedFilter, Pages } from "@model";
import { inject } from "@angular/core";
import { ResolveFn, RouterStateSnapshot } from "@angular/router";
import {extractIdFromSlug} from "@utility";

export const RaceCompetitorsPublicResolver: ResolveFn<Observable<Competitor[]>> | any =
  (route: ActivatedRouteSnapshot,
   state: RouterStateSnapshot,
   router: Router,
   competitorService: CompetitorService = inject(CompetitorService))
    : Observable<Competitor[]> => {
  const raceId = +route.queryParams['raceId'] || undefined;
  const eventIdFromQuery = +route.queryParams['eventId'] || undefined;
  const eventIdFromSlug = route.params['slug'] ? extractIdFromSlug(route.params['slug']) ?? undefined : undefined;
  const eventId = eventIdFromQuery ?? eventIdFromSlug;

  return competitorService.findCompetitors(new PagedFilter(new Pages(), {raceId:raceId, eventId:eventId}));
};

export const RaceCompetitorsPrivateResolver: ResolveFn<Observable<Competitor[]>> | any =
  (route: ActivatedRouteSnapshot,
   state: RouterStateSnapshot,
   router: Router,
   competitorService: CompetitorService = inject(CompetitorService))
    : Observable<Competitor[]> => {
    const raceId = +route.queryParams['raceId'] || undefined;
    const eventId = +route.queryParams['eventId'] || undefined;
    const isMeasurement = route.data['measurement'] ?? false;
    return competitorService.findCompetitors(new PagedFilter(new Pages(), {raceId:raceId, eventId:eventId}),true, isMeasurement);
  };
